import { render, staticRenderFns } from "./modalEditarPedido.vue?vue&type=template&id=0db81316&scoped=true&"
import script from "./modalEditarPedido.vue?vue&type=script&lang=js&"
export * from "./modalEditarPedido.vue?vue&type=script&lang=js&"
import style0 from "./modalEditarPedido.vue?vue&type=style&index=0&id=0db81316&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db81316",
  null
  
)

export default component.exports